import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import TextField from '@mui/material/TextField'

import { updateDoc } from 'lib/firestore'

export default function MailTemplateDialog({ data, onClose }) {
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({ defaultValues: data })
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(true)
  }, [])

  const onSubmit = values => {
    return updateDoc(`templates/${data.id}`, values).then(() => setOpen(false))
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)} TransitionProps={{ onExited: onClose }}>
      <DialogTitle>メールテンプレート編集</DialogTitle>
      <DialogContent>
        <Controller
          name="subject"
          defaultValue=""
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              sx={{ mb: 2 }}
              label="件名"
              helperText={errors.subject && errors.subject.message}
            />
          )}
        />
        <Controller
          name="html"
          defaultValue=""
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              multiline
              rows={12}
              style={{ mb: 2 }}
              label="メッセージ(HTML)"
              helperText={errors.html && errors.html.message}
            />
          )}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 1 }}>
        <div style={{ flex: 1 }} />
        <Button onClick={() => setOpen(false)}>キャンセル</Button>
        <Button color="primary" onClick={handleSubmit(onSubmit)} disabled={isSubmitting}>
          更新する
        </Button>
      </DialogActions>
    </Dialog>
  )
}
